import React from "react"

export const RemoveIcon = () => {
    return (
        <div id="remove-icon">
            <div className="action-text">Remove</div>
            <svg width="14" height="16" viewBox="0 0 14 16" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.1143 1.00001H9.47143L9.18607 0.41563C9.12562 0.290697 9.03251 0.185606 8.9172 0.11218C8.8019 0.0387537 8.66898 -9.46239e-05 8.53339 5.47897e-06H5.06357C4.92829 -0.00052985 4.79561 0.0381736 4.68071 0.111682C4.56581 0.18519 4.47335 0.290529 4.41393 0.41563L4.12857 1.00001H0.485714C0.356895 1.00001 0.233352 1.05268 0.142262 1.14645C0.0511733 1.24022 0 1.3674 0 1.5L0 2.5C0 2.63261 0.0511733 2.75979 0.142262 2.85356C0.233352 2.94733 0.356895 3 0.485714 3H13.1143C13.2431 3 13.3666 2.94733 13.4577 2.85356C13.5488 2.75979 13.6 2.63261 13.6 2.5V1.5C13.6 1.3674 13.5488 1.24022 13.4577 1.14645C13.3666 1.05268 13.2431 1.00001 13.1143 1.00001ZM1.615 14.5938C1.63817 14.9746 1.80144 15.332 2.07159 15.5932C2.34174 15.8545 2.69845 16 3.06911 16H10.5309C10.9016 16 11.2583 15.8545 11.5284 15.5932C11.7986 15.332 11.9618 14.9746 11.985 14.5938L12.6286 4H0.971429L1.615 14.5938Z"
                    fill="#FF3465"
                />
            </svg>
        </div>
    )
}
